import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=31c6b71d"
import script from "./ModalInfo.vue?vue&type=script&lang=js"
export * from "./ModalInfo.vue?vue&type=script&lang=js"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=31c6b71d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports